import React from 'react';
import { Box } from '@material-ui/core';
import { grey } from 'globals/colors';
import FsAbsoluteLoader from 'ui-elements/loaders/FsAbsoluteLoader';
import useTheme from '@material-ui/core/styles/useTheme';
import { PaginationInfo } from 'models/detached-actions/report';
import { TransactionType } from 'globals/types';
import FsPagination from 'ui-elements/tabs/FsPagination';
import FsExpenditureTableTransactionRow from '../FsExpenditureTableTransactionRow';
import { FsExpenditureTableTransactionRowDataProps } from '../FsExpenditureTableTransactionRow/FsExpenditureTableTransactionRow';
import { getWrapperBoxStyle } from './FsExpenditureTableTransactionsContainer.style';

interface FsExpenditureTableTransactionsContainerProps {
  transactions: Array<FsExpenditureTableTransactionRowDataProps>;
  isTransactionListPending: boolean;
  onPageChange?: (pageNumber: number) => void;
  transactionsPageNumber: number;
  paginationInfo?: PaginationInfo;
  transactionType?: TransactionType;
  categoryName: string;
}

const FsExpenditureTableTransactionsContainer: React.FC<FsExpenditureTableTransactionsContainerProps> = ({
  transactions,
  isTransactionListPending,
  onPageChange,
  transactionsPageNumber,
  paginationInfo,
  transactionType,
}) => {
  const theme = useTheme();
  const wrapperBoxStyle = getWrapperBoxStyle(theme);
  return (
    <Box
      position="relative"
      style={wrapperBoxStyle}
      data-test="expenditure-table-transactions-container"
    >
      <Box minHeight={200}>
        {transactions?.map(({ id, ...props }) => (
          <FsExpenditureTableTransactionRow
            key={id}
            id={id}
            type={transactionType}
            {...props}
          />
        ))}
        {isTransactionListPending && (
          <FsAbsoluteLoader backgroundColor={grey.V5} loaderColor={grey.V3} />
        )}
      </Box>
      {paginationInfo && (
        <FsPagination
          onPageChange={onPageChange}
          paginationInfo={paginationInfo}
          activePageNumber={transactionsPageNumber}
        />
      )}
    </Box>
  );
};

export default FsExpenditureTableTransactionsContainer;
